import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperBuySocialPlazalistPage } from './shopper-buy-social-plazalist';

@NgModule({
  declarations: [
    ShopperBuySocialPlazalistPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperBuySocialPlazalistPage),
    TranslateModule.forChild()
  ],
})
export class ShopperBuySocialPlazalistPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-social-plazalist/shopper-buy-social-plazalist.module.ts